import { useEffect, useState } from "react";
import { approvalRecords } from "../../api/community";
import { Pagination, Table, Space, Tag, Popover, Image, Modal } from "antd";
import { EyeFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import { RichText } from "@chatui/core";
import '../../style/community.css';
import UserInfoView from "../../components/community/user_info_view";
import PostReview from "../../components/community/post_review";

const CommenApproveRecordsModal = ({ commentId, modalOpen, onClose }) => {
    const [currPost, setCurrPost] = useState();
    const tabCols = [
        {
            title: 'Created',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, _) => {
                return <label style={{ fontSize: 12, color: '#afafaf', whiteSpace: 'nowrap' }}>{dayjs(text).format('MM-DD HH:mm')}</label>
            },
        },
        {
            title: 'Comment Id',
            dataIndex: 'commentId',
            key: 'commentId',
            render: (_, record) => {
                const { id } = record.comment;
                return <div style={{ fontSize: 12 }}>{id}</div>
            },
        },
        {
            title: 'Comment',
            dataIndex: 'content',
            key: 'content',
            render: (_, record) => {
                const { comment } = record;
                let resources = comment.resources;
                let content = comment.content;
                let title = comment.title;
                if(record.content) {
                    content = record.content;
                }
                if(record.title) {
                    title = record.title;
                }
                if(record.resources && record.resources.length > 0) {
                    resources = record.resources;
                }
                return (
                    <div>
                        <UserInfoView user={comment.user} showWallet={false} />
                        <div style={{ background: '#f1f1f1', padding: '8px 12px', borderRadius: 8, maxWidth: 240, marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="community-content">
                                {Array.from(resources ?? []).length > 0 ? '「IMAGE」' : ''}
                                <RichText content={title ? title : content} />
                            </div>
                            <Popover
                                placement="right"
                                title=''
                                content={
                                    <div className="post-content-review" style={{ maxWidth: 300, maxHeight: 400, overflowY: 'auto' }}>
                                        <RichText content={content} />
                                        {
                                            Array.from(resources ?? []).map(img => {
                                                return <img key={img.id} alt="addx go comment image" src={img.url} style={{ width: '100%', height: 'auto', marginTop: 8 }} />
                                            })
                                        }
                                    </div>
                                }
                                trigger={'click'}>
                                <EyeFilled style={{ color: 'grey', cursor: 'pointer' }} />
                            </Popover>
                        </div>
                    </div>
                )
            },
        },
        {
            title: 'Related Post',
            dataIndex: 'post',
            key: 'post',
            render: (_, record) => {
                const { comment } = record
                if (!comment.post || !comment.post?.user) return '-';
                return (
                    <div>
                        <UserInfoView user={comment.post?.user} showWallet={false} />
                        <div style={{ background: '#fafafa', padding: '8px 12px', borderRadius: 8, maxWidth: 240, marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="community-content">
                                <RichText content={comment.post.title ? comment.post.title : comment.post.content} />
                            </div>
                            <EyeFilled style={{ color: 'grey', cursor: 'pointer' }} onClick={() => reviewHandle(comment.post)} />
                        </div>
                    </div>
                )
            },
        },
        {
            title: 'NLP Result',
            dataIndex: 'nlpResult',
            key: 'nlpResult',
            render: (text, _) => {
                if (!text) return '';
                const nlps = JSON.parse(text);
                return (
                    <Space size={1}>
                        {nlps.map((item, index) => {
                            return <Tag key={index}>{item.name}: <b>{item.confidence}</b></Tag>
                        })}
                    </Space>
                )
            },
        },
    ];


    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        fetchData(pageNum, pageSize);
    }, [commentId])

    const fetchData = (pNum, pSize) => {
        setLoading(true);
        let params = {
            'page.num': pNum,
            'page.size': pSize,
            commentId,
        };
        approvalRecords(params).then(res => {
            if (res.page) {
                setTotal(res.page.total);
            }
            if (res.list) {
                let data = [...res.list];
                data.forEach(item => {
                    delete item['children'];
                });
                setTabData(data);
            }
        }).finally(() => setLoading(false))
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size, searchParams);
    }

    const reviewHandle = (post) => {
        setCurrPost(post);
        setOpen(true);
    }

    return (
        <>
            <Modal title='Comment Approval Records' open={modalOpen} footer={null} onCancel={onClose} width={'80vw'}>
                <div className='cnt-item'>
                    <Table
                        loading={loading}
                        rowKey={(record) => record.id}
                        rowClassName={'table-row'}
                        size='small'
                        dataSource={tabData}
                        columns={tabCols}
                        pagination={false} />
                </div>
                <div className='footer-part cnt-item'>
                    <Pagination
                        total={total}
                        showTotal={(total) => `total ${total}`}
                        current={pageNum}
                        pageSize={pageSize}
                        showSizeChanger={true}
                        pageSizeOptions={[10, 20, 30, 50]}
                        onChange={(page, size) => pageChange(page, size)}
                    />
                </div>
            </Modal>

            <PostReview
                from="comment_approval_records"
                open={open}
                post={currPost}
                onClose={() => setOpen(false)}
                onUpdate={(() => {
                    fetchData(pageNum, pageSize, searchParams);
                })}
                canEdit={false}
            />

        </>
    )
}

export default CommenApproveRecordsModal;